import { render, staticRenderFns } from "./MediaSearchTypeFilter.vue?vue&type=template&id=b4d3534a&scoped=true&"
import script from "./MediaSearchTypeFilter.vue?vue&type=script&lang=js&"
export * from "./MediaSearchTypeFilter.vue?vue&type=script&lang=js&"
import style0 from "./MediaSearchTypeFilter.vue?vue&type=style&index=0&id=b4d3534a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3534a",
  null
  
)

export default component.exports